import { useFormikContext } from 'formik'

import { LookupCreateFormValues } from '../OrderLookupForm'

type FormProps = {
  children?: React.ReactNode
}

export const Form = ({ children }: FormProps) => {
  const { handleSubmit } = useFormikContext<LookupCreateFormValues>()

  return (
    <form noValidate onSubmit={handleSubmit}>
      {children}
    </form>
  )
}
